export default "__VITE_ASSET__DdHyNiB5__"